export interface PatientPCP {
  firstName: string;
  lastName: string;
  npi: string | null;
}

export enum PcpSelectionStatus {
  NoPcpSelected = 'NO_PCP_SELECTED',
  NoPcpFound = 'NO_PCP_FOUND',
}
